import { selectExperiments } from '../selectExperiments';
import { IAppState } from 'shared/common/state';
import { AUD_HIDE_PHONE_NUMBER_EXPERIMENT } from 'shared/constants/experiments';
import { isAbUseExperimentGroup } from 'shared/utils/experiments/isAbUseExperimentGroup';

export const selectIsHidePhoneNumberExperiment = (state: IAppState) => {
  const experiments = selectExperiments(state);

  return isAbUseExperimentGroup(experiments, AUD_HIDE_PHONE_NUMBER_EXPERIMENT, 'B');
};
